import React from 'react'

import useUpdatingRef from './use-updating-ref'


export default function useKeyDown(handler) {
    const handlerRef = useUpdatingRef(handler)

    React.useEffect(() => {
        function handleKeyDown(event) {
            handlerRef.current(event)
        }
        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [])
}
